import CloseIcon from '@mui/icons-material/Close';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import { ReactElement, ReactNode } from 'react';

interface SeeMoreModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: ReactNode;
}

export function SeeMoreModal({ open, onClose, title, children }: SeeMoreModalProps): ReactElement {
  return (
    <Dialog open={open} onClose={onClose} fullWidth PaperProps={{ sx: { maxWidth: '600px' } }}>
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingRight: '8px',
          fontSize: '14px',
        }}
      >
        {title}
        <IconButton onClick={onClose} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
